import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { useApiList } from "@/hooks/useApiList";
import { AdminShell, AdminLogin } from "@/components/admin/AdminShell";
import { RequestsPanel } from "@/components/admin/RequestsPanel";
import { ReviewsPanel } from "@/components/admin/ReviewsPanel";
import { PaymentsPanel } from "@/components/admin/PaymentsPanel";
import { PricingPanel } from "@/components/admin/PricingPanel";

export default function AdminPage() {
  const auth = useAdminAuth();
  const location = useLocation();
  const [tab, setTab] = useState("demandes");
  const requests = useApiList("/requests", Boolean(auth.user), true, auth.invalidate);
  const reviews = useApiList("/reviews/admin", Boolean(auth.user), true, auth.invalidate);
  const payments = useApiList("/payments", Boolean(auth.user), true, auth.invalidate);
  const tabs = [["demandes", `Demandes (${requests.items.length})`], ["avis", `Avis (${reviews.items.length})`], ["paiements", `Paiements (${payments.items.length})`], ["tarifs", "Tarifs"]];

  let content = <p className="text-center text-slate-400 py-24" data-testid="admin-session-loading">Chargement…</p>;
  if (auth.user === null) content = <AdminLogin error={location.state?.authError || auth.error} retry={auth.error ? auth.retry : null} />;
  if (auth.user) content = <section>
    <p className="mb-5 text-sm text-slate-400 break-all" data-testid="admin-signed-in-identity">Connecté avec Google · {auth.user.email}</p>
    <div className="flex flex-wrap gap-2 mb-8" data-testid="admin-tabs">{tabs.map(([value, label]) => (
      <button key={value} onClick={() => setTab(value)} data-testid={`admin-tab-${value}`} className={`px-4 py-2.5 rounded-full text-xs font-bold uppercase border transition-colors ${tab === value ? "border-amber-400 text-amber-300 bg-amber-400/10" : "border-line text-slate-400 hover:text-slate-200"}`}>{label}</button>
    ))}</div>
    {tab === "demandes" && <RequestsPanel resource={requests} />}
    {tab === "avis" && <ReviewsPanel resource={reviews} />}
    {tab === "paiements" && <PaymentsPanel resource={payments} />}
    {tab === "tarifs" && <PricingPanel />}
  </section>;
  return <AdminShell user={auth.user} logout={auth.logout}>{content}</AdminShell>;
}